// extracted by mini-css-extract-plugin
var _1 = "pfx-CommunityFeed-module__page-title--Uu8AZ";
export { _1 as "pageTitle" }
